<template>
    <quiz-container class="quiz-init-container" :loading="loading">
        <template slot="content">
            <img class="quiz-image" :src="apiImageUrl(quizImage)" alt="Quiz header image">
            <h2 class="quiz-text">{{quizMessage}}</h2>
        </template>
        <template slot="cta-buttons">
            <button class="button pink" :class="{'main-button': !hasTakedQuiz}" @click.stop="goToQuiz">{{ hasTakedQuiz ? 'Start New' : 'Take Quiz' }}</button>
            <button class="button gray" v-if="hasTakedQuiz" @click.stop="goToResults">View Results</button>
        </template>
    </quiz-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Mixins from '../../mixins/mixins';
    import QuizContainer from './quiz-container.vue';

    export default {
        components: {
            QuizContainer,
        },
        mixins: [Mixins],
        computed: {
            hasNewQuiz() {
                return this.quizProfile.new_quiz && this.quizProfile.new_quiz.quiz_token;
            },
            hasTakedQuiz() {
                return this.quizProfile.quiz_taked && this.quizProfile.quiz_taked.quiz_token;
            },
            quizMessage() {
                return this.hasTakedQuiz ? this.quizProfile.quiz_taked.quiz_description : this.hasNewQuiz && this.quizProfile.new_quiz.quiz_description;
            },
            quizImage() {
                return this.hasTakedQuiz ? this.quizProfile.quiz_taked.quiz_image_uri : this.hasNewQuiz && this.quizProfile.new_quiz.quiz_image_uri;
            },
            ...mapGetters({
                quizProfile: 'quizzes/profile',
                loading: 'quizzes/loadingProfile',
            }),
        },
        methods: {
            goToQuiz() {
                this.$store.commit('quizzes/setCurrent', this.hasNewQuiz ? this.quizProfile.new_quiz : this.quizProfile.quiz_taked);
                this.$router.push({ path: '/quiz/new' });
            },
            goToResults() {
                this.$store.commit('quizzes/setCurrent', this.quizProfile.quiz_taked);
                this.$router.push({ path: '/quiz/result' });
            },
        },
        created() {
            if(!this.hasNewQuiz && !this.hasTakedQuiz) {
                this.$store.dispatch('quizzes/fetchQuizProfile', true);
            }
        },
        beforeRouteLeave(to, from, next) {
            if(!to.path.includes('/quiz')) {
                this.$store.commit({
                    type: 'footer/showFooter'
                });
            }
            next();
        },
    }
</script>

<style lang="scss">
    .quiz-init-container {
        .content {
            padding: 10px 20px 0;
            @media screen and (min-height: 570px) {
                padding: 60px 37px 0;
            }
            @media screen and (min-height: 669px) {
                padding: 95px 37px 0;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .content {
        .quiz {
            &-text {
                text-align: center;
                color: white;
                margin-top: 17px;            
                font-size: 20px;
                line-height: 24px;
                @media screen and (min-height: 669px) {    
                    font-size: 24px;
                    line-height: 29px;
                }   
            }
            &-image {
                border-radius: 7px;
                margin: 0 auto;
                display: block;
                @media screen and (max-height: 569px) {
                    width: 270px;    
                }
            }
        }
    }
</style>